module.exports = __webpack_public_path__ + "a8a10a3e/img/trash-icon.ff8201c7.svg";